import React, { useState, useEffect, useCallback } from 'react';
import * as XLSX from 'xlsx';
import { useDropzone } from 'react-dropzone';
import {
	Box,
	Button,
	Image,
	Input,
	Text,
	Heading,
	useToast,
	Code,
} from '@chakra-ui/react';
import uploadIcon from '../../../assets/upload_icon.png';
import AutoTypeText from '../multistepform/autotype';
import { saveAs } from 'file-saver';
import { useSelector } from 'react-redux';
import AssetsPaginatedData from './assetsPaginatedData';
import { Spinner } from "@chakra-ui/react";

const Assets = () => {
	const toast = useToast();
	const [data, setData] = useState([]);
	const [editing, setEditing] = useState(false);
	const companyId = useSelector((state) => state.companyId);
	const selectedLocation = useSelector((state) => state.selectedLocation);
	const selectedBranch = useSelector((state) => state.selectedBranch);
	const locationCode = useSelector((state) => state.locationCode);
	const [glData, setglData] = useState();
	const [storage, setStorage] = useState();
	const [uploadMessageExcel, setUploadMessageExcel] = useState();
	const [errors, setErrors] = useState([]);
	const [hasValidationErrors, setHasValidationErrors] = useState(false);
	const [errorValue, setErrorValue] = useState();
	const [totalOpenBalance, setTotalOpenBalance] = useState(0);
	const [pagesWithErrors, setPagesWithErrors] = useState(new Set());
	const [currentPage, setCurrentPage] = useState(1); // Current page
	const itemsPerPage = 50; // Number of items to display per page
	const [loading, setLoading] = useState(false);
	const [assetsBalance, setAssetsBalance] = useState([]);
	const [assetsList, setAssetsList] = useState([]);
	const [assetErrors, setAssetErrors] = useState([]);
	const [assetErrorsGlCode, setAssetErrorsGlCode] = useState([]);





	function toastCallApiError(data) {
		return toast({
			title: 'Failed to load',
			status: 'error',
			duration: 3000,
			isClosable: true,
		});
	}

	function toastCallRequestError() {
		return toast({
			title: 'Request Failed',
			status: 'error',
			duration: 3000,
			isClosable: true,
		});
	}

	// function bigPrint(number) {
	// 	const numberAsString = number.toString();
	// 	return numberAsString;
	// }
	function bigPrint(number) {
		const safeNumber = parseFloat(number);
		if (isNaN(safeNumber)) return "0";
		return safeNumber.toLocaleString("en-IN"); // nicely formatted with commas
	}


	function formatDateToDdMmYy(date) {
		const day = String(date.getDate()).padStart(2, '0'); // Get day and pad with leading zero if needed
		const month = String(date.getMonth() + 1).padStart(2, '0'); // Get month (add 1 as months are zero-indexed) and pad with leading zero if needed
		const year = String(date.getFullYear()).slice(-2); // Get the last 2 digits of the year

		return `${day}-${month}-${year}`;
	}
	const currentDate = new Date();
	const formattedDate = formatDateToDdMmYy(currentDate);

	useEffect(() => {
		const glData = async () => {
			try {
				setLoading(true);
				const response = await fetch(
					`${process.env.REACT_APP_API_URL}api-item-stock-asset.php?company_id=${companyId}&branch_id=${selectedBranch}&location_id=${selectedLocation}`,
					{
						method: 'GET',
					}
				);

				const response1 = await fetch(
					`${process.env.REACT_APP_API_URL}storage-location.php?company_id=${companyId}&branch_id=${selectedBranch}&location_id=${selectedLocation}`,
					{
						method: 'GET',
					}
				);
				if (response.ok) {
					const data = await response.json();
					const data1 = await response1.json();
					setglData(data.message);
					setStorage(data1.message);
				}
			} catch {
				toastCallApiError();
			} finally {
				setLoading(false);
			}
		};
		glData();
	}, [selectedBranch]);

	//2nd APi call
	useEffect(() => {
		const fetchAssetData = async () => {
			try {
				const response = await fetch(
					`${process.env.REACT_APP_API_URL}api-asset-balance.php?type=asset_balance&company_id=${companyId}&branch_id=${selectedBranch}&location_id=${selectedLocation}`,
					{ method: 'GET', }
				);
				if (response.ok) {
					const data = await response.json();
					setAssetsBalance(data.glValues);
				}
			} catch {
				console.log('error');
			}
		}
		fetchAssetData();
	}, [selectedBranch, selectedLocation, companyId]);
	console.log('assets_balance🟠🟠', assetsBalance);

	//3rd APi call
	useEffect(() => {
		const fetchAssetData = async () => {
			try {
				const response = await fetch(
					`${process.env.REACT_APP_API_URL}api-asset-balance.php?type=asset-list&company_id=${companyId}&branch_id=${selectedBranch}&location_id=${selectedLocation}`,
					{ method: 'GET', }
				);
				if (response.ok) {
					const data = await response.json();
					setAssetsList(data.data);
				}
			} catch {
				console.log('error');
			}
		}
		fetchAssetData();
	}, [selectedBranch, selectedLocation, companyId]);
	console.log("assetsList🟢🟢", assetsList);

	// Validation function
	const validateGlCodes = (uploadedData, apiDataArray) => {
		if (!apiDataArray) return;

		const newErrors = [];

		// 1️⃣ Group by GL Code and sum the Last_Written_Down_Value
		const groupedData = uploadedData.reduce((acc, row, idx) => {
			const glCode = String(row["Gl_Code"]).trim();
			const writtenValue = parseFloat(row["Last_Written_Down_Value"]) || 0;

			if (!acc[glCode]) {
				acc[glCode] = { total: 0, rows: [] };
			}
			acc[glCode].total += writtenValue;
			acc[glCode].rows.push(idx + 1); // keep row numbers also

			return acc;
		}, {});

		// 2️⃣ Compare each grouped total against API
		Object.entries(groupedData).forEach(([glCode, { total, rows }]) => {
			const apiRecord = apiDataArray.find(
				(apiRow) => String(apiRow.gl_code).trim() === glCode
			);

			if (apiRecord) {
				const apiValue = parseFloat(apiRecord.value) || 0;

				if (total > apiValue) {
					newErrors.push({
						type: "exceed",
						gl_code: glCode,
						totalBalance: total,
						parentValue: apiValue,
						rows,
					});
				}
			} else {
				// 🚨 GL Code not found in API
				newErrors.push({
					type: "not_found",
					gl_code: glCode,
					totalBalance: total,
					parentValue: null,
					rows,
				});
			}
		});

		setAssetErrorsGlCode(newErrors);
		setHasValidationErrors(newErrors.length > 0);
	};


	// 🔹 Asset Code + Name Validation
	const validateAssets = (uploadedData, apiAssetsList) => {
		if (!apiAssetsList) return;

		const newAssetErrors = [];

		uploadedData.forEach((row, index) => {
			const assetCode = String(row["Asset_Code"]).trim();
			const assetName = String(row["Asset_Name"]).trim();

			// Find matching API record by Asset_Code
			const apiRecord = apiAssetsList.find(
				(apiRow) => String(apiRow.item_code).trim() === assetCode
			);

			if (apiRecord) {
				// ✅ Code found, check name match
				if (apiRecord.item_name.trim() !== assetName) {
					newAssetErrors.push({
						row: index + 2, // +2 → excel row index (1 header + 0-based array)
						asset_code: assetCode,
						excelName: assetName,
						apiName: apiRecord.item_name,
					});
				}
			} else {
				// ❌ Code not found at all
				newAssetErrors.push({
					row: index + 2,
					asset_code: assetCode,
					excelName: assetName,
					apiName: null,
				});
			}
		});

		setAssetErrors(newAssetErrors);
	};


	useEffect(() => {
		if (data.length > 0 && assetsBalance) {
			validateGlCodes(data, assetsBalance); // assetsList is already the array
		}
	}, [data, assetsBalance]);

	useEffect(() => {
		if (data.length > 0 && assetsList.length > 0) {
			validateAssets(data, assetsList);
		}
	}, [data, assetsList]);

	useEffect(() => {
		// Calculate the errorValue based on the errors state
		const newErrorValue = errors.reduce((acc, rowErrors) => {
			return (
				acc +
				Object.values(rowErrors).filter((error) => error !== null)
					.length
			);
		}, 0);

		setErrorValue(newErrorValue);
	}, [errors]); // Watch for changes in the errors state


	const handleFileDrop = useCallback((acceptedFiles) => {
		const file = acceptedFiles[0];
		const reader = new FileReader();

		reader.onload = (event) => {
			const data = new Uint8Array(event.target.result);
			const workbook = XLSX.read(data, { type: 'array' });

			const sheetName = workbook.SheetNames[0];
			const worksheet = workbook.Sheets[sheetName];

			const excelData = XLSX.utils.sheet_to_json(worksheet, {
				header: 1,
			});

			const headers = excelData[0].map((header) => header.trim());
			const formattedData = excelData.slice(1).map((row) => {
				const rowData = {};
				row.forEach((cell, columnIndex) => {
					const header = headers[columnIndex];
					rowData[header] = cell;

					// Check if the column is a date column by header name
					if (header === 'Put_to_Use_Date' || header === 'Date_of_Acquisition_GNRDate' || header === 'Invoice_Date' || header === 'Last_Depreciation_Run') {
						// Handle numeric date values (Excel serial numbers)
						if (typeof cell === 'number') {
							const numericDate = parseFloat(cell);
							// Convert Excel serial number to JavaScript Date
							const millisecondsSinceEpoch = (numericDate - 25569) * 86400 * 1000;
							const dateObject = new Date(millisecondsSinceEpoch);

							// Format the date in yyyy-mm-dd format (e.g., 2024-06-03)
							const year = dateObject.getFullYear();
							const month = String(dateObject.getMonth() + 1).padStart(2, '0'); // Pad with leading zero
							const day = String(dateObject.getDate()).padStart(2, '0'); // Pad with leading zero

							rowData[header] = `${year}-${month}-${day}`;
						} else {

							if (cell && typeof cell === 'string') {
								const date = new Date(cell);
								if (!isNaN(date.getTime())) {
									const year = date.getFullYear();
									const month = String(date.getMonth() + 1).padStart(2, '0');
									const day = String(date.getDate()).padStart(2, '0');
									rowData[header] = `${year}-${month}-${day}`;
								} else {
									rowData[header] = cell; // Keep as is if not a valid date
								}
							} else {
								rowData[header] = cell || '';
							}
						}
					}

				});
				return rowData;
			});

			// Fill missing keys with empty strings
			const emptyRow = Object.fromEntries(headers.map((header) => [header, '']));
			const dataWithEmptyKeys = formattedData.map((row) => ({
				...emptyRow,
				...row,
			}));

			// Filter out blank rows
			const nonBlankRows = dataWithEmptyKeys.filter((row) => {
				return Object.values(row).some(
					(cellValue) => cellValue !== null && cellValue !== ''
				);
			});

			setData(nonBlankRows);
		};

		reader.readAsArrayBuffer(file);
	}, []);

	const { getRootProps, getInputProps, isDragActive } = useDropzone({
		onDrop: handleFileDrop,
		accept: '.xlsx',
	});

	const demoXLSX = glData;
	function generateXLSXData(demoXLSX) {
		const headers = Object.keys(demoXLSX[0]); // Get the keys from the first object as headers

		const data = demoXLSX.map((item) => {
			return headers.map((header) => item[header]);
		});

		const worksheet = XLSX.utils.aoa_to_sheet([headers, ...data]);
		const workbook = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

		const excelBuffer = XLSX.write(workbook, {
			bookType: 'xlsx',
			type: 'array',
		});

		return excelBuffer;
	}

	const handleDownload = () => {
		if (demoXLSX && demoXLSX.length > 0) {
			const updatedData = demoXLSX.map((asset) => ({
				// ...asset,
				Gl_Code: '',
				Gl_Name: '',
				Asset_Code: `${asset.itemCode}`,
				Asset_Name: `${asset.itemName}`,
				Assets_Description: '',
				Batch_No: '',
				Equip_No: '',
				Storage_Location: '',
				Issued_to_Cost_Center: '',
				GNR_Details: '',
				Date_of_Acquisition_GNRDate: '',
				Invoice_Number: '',
				Invoice_Date: '',
				Supplier_Name: '',
				Supplier_GSTN: '',
				Supplier_Address: '',
				Qty: '',
				UOM: '',
				Basic_Value: '',
				GST: '',
				Total_Value: '',
				Historical_Cost: '',
				Put_to_Use_Date: '',
				Useful_Life: '',
				Depreciation_Rate: '',
				Depreciation_Method: '',
				Written_Down_Value: '',
				Last_Written_Down_Value: '',
				last_depreciation_run: '',
				Accumulated_Depreciations: '',
			}));

			const worksheet = XLSX.utils.json_to_sheet(updatedData);
			const workbook = XLSX.utils.book_new();
			XLSX.utils.book_append_sheet(workbook, worksheet, "Assets");

			const excelBuffer = XLSX.write(workbook, {
				bookType: "xlsx",
				type: "array",
			});
			const blob = new Blob([excelBuffer], {
				type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
			});
			saveAs(blob, `Assets-${locationCode}-${formattedDate}.xlsx`);
		} else {
			// Case 2: No data → export only headers
			const headers = [
				"Gl_Code",
				"Gl_Name",
				"Asset_Code",
				"Asset_Name",
				"Assets_Description",
				"Batch_No",
				"Equip_No",
				"Storage_Location",
				"Issued_to_Cost_Center",
				"GNR_Details",
				"Date_of_Acquisition_GNRDate",
				"Invoice_Number",
				"Invoice_Date",
				"Supplier_Name",
				"Supplier_GSTN",
				"Supplier_Address",
				"Qty",
				"UOM",
				"Basic_Value",
				"GST",
				"Total_Value",
				"Historical_Cost",
				"Put_to_Use_Date",
				"Useful_Life",
				"Depreciation_Rate",
				"Depreciation_Method",
				"Written_Down_Value",
				"Last_Written_Down_Value",
				"Accumulated_Depreciations",
			];

			const worksheet = XLSX.utils.aoa_to_sheet([headers]);
			const workbook = XLSX.utils.book_new();
			XLSX.utils.book_append_sheet(workbook, worksheet, "Assets");

			const excelBuffer = XLSX.write(workbook, {
				bookType: "xlsx",
				type: "array",
			});
			const blob = new Blob([excelBuffer], {
				type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
			});
			saveAs(blob, `Assets-Template.xlsx`);
		}
	};


	// storage location
	const storageXlSX = storage;
	function generateStorageData(storageXlSX) {
		const headers = Object.keys(storageXlSX[0]); // Get the keys from the first object as headers

		const data = storageXlSX.map((item) => {
			return headers.map((header) => item[header]);
		});

		const worksheet = XLSX.utils.aoa_to_sheet([headers, ...data]);
		const workbook = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

		const excelBuffer = XLSX.write(workbook, {
			bookType: 'xlsx',
			type: 'array',
		});

		return excelBuffer;
	}
	const storageHandleDownload = () => {
		if (storageXlSX !== undefined) {
			const updatedData = storageXlSX?.map((asset) => ({
				...asset,
			}));

			const excelData = generateStorageData(updatedData);
			const blob = new Blob([excelData], {
				type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
			});

			saveAs(
				blob,
				`Storage-Location-${locationCode}-${formattedDate}.xlsx`
			);
		} else {
			toastCallRequestError();
		}
	};

	const handlePageChange = (newPage) => {
		setCurrentPage(newPage);
	};

	return (
		<Box
			width='100%'
			height='100%'
			display='flex'
			justifyContent='center'
			alignItems='center'
			flexDirection='column'>
			<Box w='100%' display='flex' justifyContent='space-between'>
				<Box
					width='38%'
					display='flex'
					justifyContent='space-around'
					alignItems='center'>
					<Box width='400px'>
						<Box
							border='2px dashed var(--chakra-colors-bgGraycolor)'
							p='15px'
							borderRadius='20px'
							opacity={editing ? '0.5' : '1'}
							pointerEvents={editing ? 'none' : 'painted'}>
							<Box
								{...getRootProps()}
								bg='var(--chakra-colors-mainBlueColor)'
								width='100%'
								height='100%'
								borderRadius='20px'
								display='flex'
								justifyContent='center'
								alignItems='center'
								color='white'
								padding='50px 0px'
								cursor='grab'>
								<Input {...getInputProps()} />
								{isDragActive ? (
									<Box
										display='flex'
										flexDirection='column'
										justifyContent='center'
										alignItems='center'>
										<Image
											src={uploadIcon}
											alt='upload icon'
											height='100px'
											width='100px'
										/>
										<Text>Drop the Excel file here...</Text>
									</Box>
								) : (
									<Box
										display='flex'
										flexDirection='column'
										justifyContent='center'
										alignItems='center'>
										<Image
											src={uploadIcon}
											alt='upload icon'
											height='100px'
											width='100px'
										/>
										<Text>Drag & Drop your files</Text>
									</Box>
								)}
							</Box>
						</Box>
						<Box
							display='flex'
							width='100%'
							justifyContent='center'
							gap='15px'
							paddingTop='45px'>
							<Button
								borderRadius='10px'
								border='1px solid #003060'
								p='20px 30px'
								width='100%'
								fontSize='15px'
								background='none'
								color='mainBlueColor'
								onClick={handleDownload}
								cursor='pointer'>
								Download Sample
							</Button>
							<Button
								borderRadius='10px'
								border='1px solid #003060'
								p='20px 30px'
								width='100%'
								fontSize='15px'
								background='none'
								color='mainBlueColor'
								onClick={storageHandleDownload}
								cursor='pointer'>
								Storage Location
							</Button>
						</Box>
					</Box>
				</Box>

				<Box
					width='58%'
					boxShadow='rgba(0, 0, 0, 0.24) 0px 3px 8px'
					borderRadius='15px'
					padding='15px'>
					<Heading
						mb='15px'
						color='var(--chakra-colors-mainBlueColor)'
						fontSize='28px'>
						Data Summary :{' '}
					</Heading>
					{loading && (
						<Box display="flex" justifyContent="center" mb="15px">
							<Spinner size="lg" color="blue.500" />
						</Box>
					)}
					<Text
						fontSize='1.7rem'
						fontWeight='600'
						marginBottom='10px'
						color='green'>
						Total lines : {data?.length}
					</Text>
					<Text
						fontSize='1.7rem'
						fontWeight='600'
						marginBottom='10px'
						color='red'>
						Total Error : {errorValue}
					</Text>
					{assetErrorsGlCode.length > 0 && (
						<Text
							fontSize="1.7rem"
							fontWeight="600"
							marginBottom="10px"
							color="red"
						>
							⚠️ Warning:{" "}
							{assetErrorsGlCode
								.map((err) => {
									if (err.type === "exceed") {
										return `Row(s) ${err.rows.join(", ")} → GL: ${err.gl_code} (Uploaded: ${bigPrint(
											err.totalBalance
										)}, Allowed: ${bigPrint(err.parentValue)})`;
									} else if (err.type === "not_found") {
										return `Row(s) ${err.rows.join(", ")} → GL: ${err.gl_code} ❌ Not found in API`;
									}
									return "";
								})
								.join(" | ")}
						</Text>
					)}

					{assetErrors.length > 0 && (
						<Text
							fontSize="1.4rem"
							fontWeight="600"
							marginBottom="10px"
							color="orange"
						>
							⚠️ Warning: Asset issues found →{" "}
							{assetErrors
								.map((err) => {
									if (err.apiName) {
										return `Row ${err.row} → Asset_Code ${err.asset_code} → Asset Name mismatch (Excel: "${err.excelName}", API: "${err.apiName}")`;
									} else {
										return `Row ${err.row} → Asset_Code ${err.asset_code} not found in API (Excel Name: "${err.excelName}")`;
									}
								})
								.join(" | ")}
						</Text>
					)}

					{/* Display the total OPEN_BALANCE */}
					<Text
						fontSize='1.7rem'
						fontWeight='600'
						color='mainBlueColor'
						marginBottom='5px'>
						Balance: {bigPrint(totalOpenBalance)}
					</Text>
					<Box mt='10px' mb='10px'>
						<Box
							fontSize='1.7rem'
							fontWeight='600'
							color='mainBlueColor'>
							Pages with errors:
						</Box>

						{Array.from(pagesWithErrors).join(', ')}
					</Box>
					<Box>
						<Text
							fontSize='1.7rem'
							fontWeight='600'
							color='mainBlueColor'
							marginBottom='5px'>
							Data Review Report -
						</Text>
						<AutoTypeText />
					</Box>
				</Box>
			</Box>
			<AssetsPaginatedData
				data={data}
				setData={setData}
				currentPage={currentPage}
				itemsPerPage={itemsPerPage}
				editing={editing}
				setEditing={setEditing}
				onPageChange={handlePageChange}
				setTotalOpenBalance={setTotalOpenBalance}
				setErrorValue={setErrorValue}
				errorValue={errorValue}
				errors={errors}
				setErrors={setErrors}
				hasValidationErrors={hasValidationErrors}
				setHasValidationErrors={setHasValidationErrors}
				setPagesWithErrors={setPagesWithErrors}
				uploadMessageExcel={uploadMessageExcel}
				setUploadMessageExcel={setUploadMessageExcel}
				assetErrorsGlCode={assetErrorsGlCode}
				assetErrors={assetErrors}
			/>
		</Box>
	);
};

export default Assets;
